'use strict';
module.exports = {
    children: require('./lib/children')
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-utils/index.js
 ** module id = 149
 ** module chunks = 0
 **/